


































import {Component, Prop, Vue} from 'vue-property-decorator';

@Component({
  name: "tooltip"
})
export default class Search extends Vue {
  @Prop({type: [String], default: ''}) protected tooltip!: string
  @Prop({type: [String], default: ''}) protected text!: string
  @Prop({type: [String], default: ''}) protected icon!: string
  @Prop({type: [String], default: ''}) protected iconColor!: string
  @Prop({type: [Boolean], default: false}) protected top!: boolean
  @Prop({type: [Boolean], default: false}) protected left!: boolean
  @Prop({type: [Boolean], default: false}) protected bottom!: boolean
  @Prop({type: [Boolean], default: false}) protected right!: boolean
  @Prop({type: [Boolean], default: false}) protected blue!: boolean
  @Prop({type: [Boolean], default: false}) protected isIcon!: boolean
  @Prop({type: [Boolean], default: false}) protected isIconSmall!: boolean
  @Prop({type: [Boolean], default: false}) protected disabled!: boolean
  @Prop({type: [Boolean], default: false}) protected isFlex!: boolean
  @Prop({type: [Boolean], default: false}) protected isStretch!: boolean
  @Prop({type: [Boolean], default: false}) protected isDisabledTooltip!: boolean
  @Prop({type: [String], default: ''}) protected hotKey!: string
  @Prop({type: [String], default: 'none'}) protected maxWidth!: string
  @Prop({type: [String], default: ''}) protected contentClass!: string
  @Prop({type: [String], default: '0'}) protected delay!: string
  @Prop({type: [String], default: ''}) protected styleCurrent!: string
  @Prop({type: [String], default: ''}) value !:any


  clickTooltipBtn() {
    this.$emit('clickTooltipBtn')
  }

  get currentTooltip() {
    return this.tooltip.length > 500 ? this.tooltip.substr(0,500)+'...' : this.tooltip
  }

}
